import { Component, EventEmitter, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PreventScrollDirective } from '../../../directives/prevent-scroll.directive';

@Component({
    selector: 'app-logout-modal',
    standalone: true,
    imports: [CommonModule, PreventScrollDirective],
    templateUrl: './logout-modal.html'
})
export class LogoutModal {
    @Output() close = new EventEmitter<void>();
    @Output() confirm = new EventEmitter<void>();

    isLoggingOut = signal(false);

    /**
     * Emits the close event to dismiss the modal
     */
    closeModal() {
        this.close.emit();
    }

    /**
     * Emits the confirm event to proceed with logout
     */
    confirmLogout() {
        this.confirm.emit();
    }
}
